import styled from "styled-components"
import { Row, Col, Container } from "react-bootstrap";
import { HoverCardBorder } from "../styled/BPSCards";
import { FadeLoad, FadeScroll } from "../styled/Motion.styled";


const ChannelCards = () => {
    return (
        <>
            <Container fluid className="py-5">
                <Row className="justify-content-center">
                    <Col lg={4} md={6} className="my-3">
                        <FadeScroll className="h-100">
                            <HoverCardBorder>
                                <h3 className='fs-20'>Full-service incentive program management</h3>
                                <p>
                                    From conception to completion, Best Payment Solutions handles the creation, implementation, and management of every aspect of your channel sales incentive program.
                                </p>
                            </HoverCardBorder>
                        </FadeScroll>
                    </Col>
                    <Col lg={4} md={6} className="my-3">
                        <FadeScroll className="h-100">
                            <HoverCardBorder>
                                <h3 className='fs-20'>Flexibility & multi-program management</h3>
                                <p>
                                    We have worked with everyone from manufacturers, dealers, and consumers, creating channel programs that are adaptable to your unique business needs. With our fully customizable program design and management technology, clients can easily run several promotions simultaneously on one platform. Every promotion runs seamlessly from beginning to end.
                                </p>
                            </HoverCardBorder>
                        </FadeScroll>
                    </Col>
                </Row>
                <Row className="justify-content-center">
                    <Col xl={3} lg={4} md={4} className="my-3">
                        <FadeScroll className="h-100">
                            <HoverCardBorder>
                                <h3 className='fs-20'>Quick setup & engaging program launch</h3>
                                <p>
                                    We work efficiently to get your incentive program site up and running in less than 90 days. To ensure a successful launch, we not only introduce participants to the upcoming promotion but also guide them through the program details and registration process.
                                </p>
                            </HoverCardBorder>
                        </FadeScroll>
                    </Col>
                    <Col xl={3} lg={4} md={4} className="my-3">
                        <FadeScroll className="h-100">
                            <HoverCardBorder>
                                <h3 className='fs-20'>Real-time data & analytics</h3>
                                <p>
                                    Easily review participant submissions, process sales claims, and view claim status. From our administrator dashboard, you can view program data such as the number of pending, approved, and declined claims, top dealers, regional front-runners, and program funds.
                                </p>
                            </HoverCardBorder>
                        </FadeScroll>
                    </Col>
                    <Col xl={3} lg={4} md={4} className="my-3">
                        <FadeScroll className="h-100">
                            <HoverCardBorder>
                                <h3 className='fs-20'>Innovative themes</h3>
                                <p>
                                    We craft unique themes tailored to each client program. These themes are the base point for every element of the participant’s interaction with the program. This includes custom mobile-responsive websites, announcement brochures, participant emails, and promotional items.
                                </p>
                            </HoverCardBorder>
                        </FadeScroll>
                    </Col>
                </Row>
                <Row className="justify-content-center">
                    <Col lg={4} md={6} className="my-3">
                        <FadeScroll className="h-100">
                            <HoverCardBorder>
                                <h3 className='fs-20'>Sales claim submissions & seamless tech integration</h3>
                                <p>
                                    Program participants can easily upload their sales claims by using our uploader tool, which encourages consistent sales and engagement. Best Payment Solutions guarantees seamless integration with your tech teams. We offer customizable options and integrations for the program website, powerful data security measures, and robust claim validation processes.
                                </p>
                            </HoverCardBorder>
                        </FadeScroll>
                    </Col>
                    <Col lg={4} md={6} className="my-3">
                        <FadeScroll className="h-100">
                            <HoverCardBorder>
                                <h3 className='fs-20'>Active communication & dedicated customer service</h3>
                                <p>
                                    We maintain ongoing communication via email and outbound call campaigns. This ensures sustained awareness and engagement to motivate participants. Our amazing customer service representatives guarantee top-tier service for both our clients and participants.
                                </p>
                            </HoverCardBorder>
                        </FadeScroll>
                    </Col>
                </Row>
            </Container>
        </>
    );
}


export { ChannelCards }
